import { installDynamicImportRecovery } from '@/lib/dynamic-import-recovery'

installDynamicImportRecovery()
